//Utility class has some helper methods
export class Utils {
    //check if param string is empty
    static IsStringNullOrEmpty(str: any) {
      if (str == null || str == undefined || str == "") {
        return true;
      }
      return false;
    }

    static calculateAcrestoHectares(value: number){
      if(value != 0){
        return value * 0.404686 //fixed value for 1acre to hectare
      }
      return value.toFixed(2);
    }

    //check if param object is empty
    static IsObjectNullOrEmpty(object: any) {
      if (
        Object.values(object).length === 0 ||
        object == null ||
        object == undefined
      ) {
        return true;
      }
      return false;
    }
  }